import { ChatbotsPage } from './chatbots-page.component';

export default ChatbotsPage;
